import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/bundle/usage-history/summary'

const initialState = () => ({
    usageHistorySummary: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        usageHistorySummary: state => state.usageHistorySummary.data,
        pagination: state => state.usageHistorySummary.pagination
    },
    actions: {
        listUsageHistorySummary: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listUsageHistorySummary(data)
                const usageHistorySummary = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_USAGE_HISTORY_SUMMARY, usageHistorySummary)
                return usageHistorySummary
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetUsageHistorySummary: ({commit}) => commit(mutationTypes.RESET_USAGE_HISTORY_SUMMARY)
    },
    mutations: {
        [mutationTypes.SET_USAGE_HISTORY_SUMMARY]: (state, data) => state.usageHistorySummary = data,
        [mutationTypes.RESET_USAGE_HISTORY_SUMMARY]: (state) => Object.assign(state, initialState())
    }
}
